module.exports = __webpack_public_path__ + "img/ion_share-outline.e20e9606.png";